import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faPlus } from '@fortawesome/pro-light-svg-icons'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'
import { Box, Button } from '@domain-group/suit-theme'

import type { TaskListModel } from '@models/taskList'

import { generateUrls } from '@hooks/useTaskList'
import useTaskListSection from '@hooks/useTaskListSection'
import useTaskListSections from '@hooks/useTaskListSections'

import TaskListSection from './TaskListSection'

interface TaskListSectionsProps {
  taskList: Partial<TaskListModel>,
}

const TaskListSections = (props: TaskListSectionsProps) => {
  const { taskList } = props

  const urls = generateUrls(taskList)
  const { editTaskListTasksUrl } = urls

  const { taskListSectionId } = parsePermittedQueryParams(getQueryParamsFromHash(), ['taskListSectionId'])

  const taskListSectionPayload = useTaskListSection({
    debtor_id: taskList.debtor_id,
    debtor_type: taskList.debtor_type,
    task_list_id: taskList.id,
  })

  const { callbacks: { createOrEditTaskListSection } } = taskListSectionPayload

  const taskListSectionsPayload = useTaskListSections({
    filters: {
      id: taskListSectionId,
      task_list_id: taskList.id,
    },
  })

  const { filteredTaskListSections, loading } = taskListSectionsPayload

  return (
    <>
      {filteredTaskListSections.map(taskListSection => (
        <TaskListSection key={taskListSection.id} taskListSection={taskListSection} />
      ))}

      {!!taskList.id && !loading && !taskListSectionId && (
        <Box padding="large" variant="white">
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditTaskListSection()}
            size="medium"
          >
            Add Another Group
          </Button>
        </Box>
      )}

      {!!taskList.id && !loading && !!taskListSectionId && (
        <Box padding="large" variant="white">
          <Button
            as="a"
            buttonStyle="secondaryEdit"
            href={editTaskListTasksUrl}
            icon={<FontAwesomeIcon icon={faFilter} />}
            size="medium"
          >
            Show All Groups
          </Button>
        </Box>
      )}
    </>
  )
}

export default TaskListSections
